import {ChangeDetectionStrategy, Component, computed, inject, input, Signal} from '@angular/core';
import {NgStyle} from '@angular/common';
import {StoryblokService} from '@core/services/storyblok.service';
import {StoryblokDirective} from '@core/directives/storyblok.directive';
import {
  SpotV2Obj,
  StoryblokSpotV2Component
} from '@modules/storyblok/components/storyblok-spots-v2/storyblok-spot-v2/storyblok-spot-v2.component';

@Component({
  selector: 'app-storyblok-spots-v2',
  templateUrl: './storyblok-spots-v2.component.html',
  styleUrls: ['./storyblok-spots-v2.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgStyle, StoryblokDirective, StoryblokSpotV2Component]
})
export class StoryblokSpotsV2Component {
  desktop_columns = input<number>(3);
  tablet_columns = input<number>(2);
  mobile_columns = input<number>(1);
  spots = input<any>();
  spotsData: Signal<{ spot: SpotV2Obj, originalObj: any }[]> = computed(() => {
    return this.spots().map((d: any) => {
      return {
        spot: this.getSpot(d),
        originalObj: d,
      }
    });
  });
  readonly _editable = input<any>();
  gridStyles = computed(() => {
    const desktopCols = this.desktop_columns() || 3;
    const tabletCols = this.tablet_columns() || 2;
    const mobileCols = this.mobile_columns() || 1;

    return {
      '--grid-cols-mobile': mobileCols.toString(),
      '--grid-cols-tablet': tabletCols.toString(),
      '--grid-cols-desktop': desktopCols.toString()
    };
  });
  private storyblokService = inject(StoryblokService);

  getSpot(spot: any): SpotV2Obj {
    const {imgWidth, imgHeight} = this.getImageSize(spot);

    return {
      title: spot.title,
      description: spot.description,
      ctaText: spot.ctaText,
      ctaLink: spot.ctaLink.cached_url,
      ctaDesign: spot.ctaDesign,
      backgroundImage: spot.backgroundImage?.filename,
      imgHeight,
      imgWidth
    };
  }

  protected getImageSize(spot: any): { imgHeight: number | undefined, imgWidth: number | undefined } {
    const filename = spot.backgroundImage.filename as string;
    return this.storyblokService.getImageSize(filename);
  }

}
